import {
  SET_DATA,
  SET_SHOW_MORE,
  SET_FILTER,
  REMOVE_FILTER,
  RESET_DATA,
} from 'js/store/content-filter/ContentFilter.actions.js';

const ITEM_DISPLAY_INCREMENT = 3;

const initState = {
  contentType: '',
  content: [],
  activeFilters: [],
  displayItemCount: 3,
  canShowMore: true,
};

const contentFilter = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case RESET_DATA: {
      nextState = { ...initState };
      return { ...state, ...nextState };
    }

    case SET_DATA: {
      nextState.contentType = action.payload.type;
      nextState.content = action.payload.data;

      if (action.payload.data.length === 0 || action.payload.data.length <= state.displayItemCount) {
        nextState.canShowMore = false;
      }
      return { ...state, ...nextState };
    }

    case SET_SHOW_MORE: {
      const itemCount = state.content.length;
      if (state.displayItemCount + ITEM_DISPLAY_INCREMENT <= itemCount) {
        nextState.displayItemCount = state.displayItemCount + ITEM_DISPLAY_INCREMENT;

        if (state.displayItemCount + ITEM_DISPLAY_INCREMENT == itemCount) {
          nextState.canShowMore = false;
        }
      } else {
        nextState.canShowMore = false;
        nextState.displayItemCount = itemCount;
      }

      return { ...state, ...nextState };
    }
  }
  return state;
};

export default contentFilter;
